import { RxapDataSource, BaseDataSource } from 'eurogard-data-source';
import { Injectable, Injector, OnInit, inject } from '@angular/core';
import { from, shareReplay } from 'rxjs';
import { UserControllerMeGUIResponse } from 'open-api-legacy/responses/user-controller-me-gui.response';
import { UserSettingsAccordionDataSource } from './user-settings-accordion.data-source';
import { toObservable } from '@angular/core/rxjs-interop';
import { isDefined } from '@rxap/rxjs';

@Injectable()
@RxapDataSource('user-info')
export class UserInfoDataSource extends BaseDataSource<UserControllerMeGUIResponse> implements OnInit {
  protected readonly dataSource = inject(UserSettingsAccordionDataSource);
  private injector = inject(Injector);

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit() {
    this._data$ = from(toObservable(this.dataSource.user, { injector: this.injector })).pipe(
      isDefined(),
      shareReplay(1)
    );
  }
}
